import AbstractValue from '@/models/app-config/behavior/abstract-value'
import { Notification, RawNotification } from './notification'
import Promotion, { RawPromotion } from './promotion'

export interface RawCart {
  promotion: RawPromotion
  notification: RawNotification
}

export default class Cart extends AbstractValue<RawCart> {
  get promotion(): Promotion {
    return new Promotion(this.raw.promotion)
  }
  get notification(): Notification {
    return new Notification(this.raw.notification)
  }
}
